import { isEmpty } from "lodash";
import { isAllLocationSelected, openUrlInTab } from "../library/helpers";
import { removeLocalStorage, setLocalStorage } from "../utils/storages";
import { ROUTES } from "../Routes";

// Otto Analytics Metric Types Constants
export const OTTO_METRIC_TYPES = {
  AUTO_RESPONDER: "auto-responder",
  APPOINTMENTS_MANAGED: "appointments-managed",
  TASKS_CREATED: "tasks-created",
  REVIEWS_WRITTEN: "otto-reviews-written",
  CAMPAIGNS_MESSAGES: "campaigns-messages",
  CALLS_SUMMARIZED: "calls-summarized",
  NOTES: "notes",
  EMAIL_GENERATED: "email-generated",
  AFTER_HOURS_ENGAGEMENTS: "after-hours-engagements",
};

export const OTTO_ANALYTICS_CLASSES = {
  label: "text-sm font-normal text-black/[0.88]",
  labelClickable: "text-sm font-normal text-[#1677FF] cursor-pointer",
};

export const OTTO_ANALYTICS_PAGINATION = {
  showSizeChanger: true,
  showQuickJumper: false,
  pageSize: 10,
  pageSizeOptions: [10, 20, 50],
  currentPage: 1,
};

export const DATE_PICKER_FORMAT = "YYYY-MM-DD";

// Helper function to generate activity center URL with leadId
export const gotoActivityCenter = lead => {
  // const isAllLocation = isAllLocationSelected();
  // if (isAllLocation) {
  //   removeLocalStorage("clickLeadId");
  //   if (!isEmpty(lead?.phones)) {
  //     const phoneNumbers = lead?.phones?.find(phone => phone.isPrimary);
  //     const url = `/engagements/activity-center/${phoneNumbers?.phone}`;
  //     openUrlInTab(url);
  //   } else if (!isEmpty(lead?.emails)) {
  //     const email = lead?.emails?.find(email => email.isPrimary);
  //     const url = `/engagements/activity-center/${email?.email}`;
  //     openUrlInTab(url);
  //   } else {
  //     openUrlInTab("/engagements/activity-center");
  //   }
  // } else {
  //   setLocalStorage("clickLeadId", lead.id);
  //   openUrlInTab("/engagements/activity-center", "_blank", true);
  // }
  // setLocalStorage("clickLeadId", lead.id);
  const url = `${ROUTES.activityCenter}?leadId=${lead.id}`;
  openUrlInTab(url, "_blank", true);
};

export const REVIEW_RATE_FILTERS = [
  { text: "5 Stars", value: 5 },
  { text: "4 Stars", value: 4 },
  { text: "3 Stars", value: 3 },
  { text: "2 Stars", value: 2 },
  { text: "1 Star", value: 1 },
];

export const getAppointmentStatusColor = status => {
  const colors = {
    SCHEDULED: "blue",
    NO_SHOWED: "grey",
    SHOWED: "yellow",
    CANCELLED: "red",
    CONFIRMED: "green",
    RESCHEDULED: "purple",
    REMINDER: "orange",
  };

  return colors[status] || "default";
};

export const APPOINTMENT_STATUS_FILTERS = [
  { text: "Scheduled", value: "SCHEDULED" },
  { text: "No showed", value: "NO_SHOWED" },
  { text: "Showed", value: "SHOWED" },
  { text: "Cancelled", value: "CANCELLED" },
  { text: "Confirmed", value: "CONFIRMED" },
  { text: "Rescheduled", value: "RESCHEDULED" },
];

// Activity options for the Ottolytics appointments detail table. Same set as
// the appointment statuses plus REMINDER, which only exists as an activity.
export const APPOINTMENT_ACTIVITY_FILTERS = [
  ...APPOINTMENT_STATUS_FILTERS,
  { text: "Reminder", value: "REMINDER" },
];

// All appointment status values — the "all selected" default applied on
// initial state and by reset flows (logout, Add Appointment).
export const APPOINTMENT_STATUSES = APPOINTMENT_STATUS_FILTERS.map(s => s.value);

export const CALL_FILTERS = [
  { text: "Inbound", value: "INBOUND" },
  { text: "Outbound", value: "OUTBOUND" },
];

export const EMAIL_FILTERS = [
  { text: "Delivered", value: "DELIVERED" },
  { text: "Opened", value: "OPENED" },
  { text: "Clicked", value: "CLICKED" },
  { text: "Bounced", value: "BOUNCE" },
  { text: "Sent", value: "SENT" },
  { text: "Queued", value: "QUEUED" },
  { text: "Complaint", value: "COMPLAINT" },
  { text: "Rejected", value: "REJECTED" },
];

export const metricTabClass = "bg-white rounded-xl px-5 py-2";

export const METRIC_DETAIL_MODE = {
  OTTO: "otto",
  EMPLOYEE: "employee",
  AI_ASSISTED: "ai_assisted",
};

export const OTTO_ACTION_STATUS = {
  CAMPAIGNS_MESSAGES: "campaigns_messages",
  CALLS_SUMMARIZED: "calls_summarized",
};

export const VEHICLE_TRADE_LIST_RECORD_LIMIT = 3;

export const VEHICLE_TRADE_CATEGORIES = {
  BUY: "buy",
  SELL: "sell",
  SOLD: "sold",
};

export const OTTO_METRICS_STATUS = {
  REVIEWS_WRITTEN: "reviews_written",
};
